import React, { useEffect, useMemo } from 'react';
import { Tabs, Tab, Grid } from '@nextiva/next-ui-components';
import { useImmerReducer } from 'use-immer';

import { TabPanel } from 'components';
import { Page } from 'containers';
import { useRootUserList } from 'customHooks/userCustomHooks';

import {
  initialState,
  LicensesContext,
  actionTypes,
  licensesReducer,
} from './licensesContext';
import LicensesTabPanel from './LicensesTabPanel';

const BillingLicenses = () => {
  const {
    rootState: { rootUserListLoading, rootUserListError, rootUserList },
  } = useRootUserList();
  const [licensesState, dispatch] = useImmerReducer(
    licensesReducer,
    initialState,
  );

  const contextValue = useMemo(
    () => ({
      licensesState,
      dispatch,
    }),
    [licensesState],
  );

  useEffect(() => {
    if (rootUserListLoading || rootUserListError) {
      return;
    }

    dispatch({
      type: actionTypes.SET_LICENSES_USER_LIST,
      licensesUserList: rootUserList,
    });
  }, [rootUserListLoading, rootUserListError, rootUserList]);

  return (
    <Page title="Licensing" className="m-billing-licenses">
      <Grid className="m-tabs" container>
        <Grid item xs={12}>
          <Tabs value={0}>
            <Tab label="licenses" />
          </Tabs>
        </Grid>
        <Grid item xs={12}>
          <TabPanel value={0} index={0}>
            <LicensesContext.Provider value={contextValue}>
              <LicensesTabPanel />
            </LicensesContext.Provider>
          </TabPanel>
        </Grid>
      </Grid>
    </Page>
  );
};

export default BillingLicenses;
